import { Component, Input, OnInit } from '@angular/core';
import { ReferringPhysicianView } from '../../../../model/referring-physician/referring-physician-view';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { PhysicianService } from '../../../../services/physician.service';

@Component({
  selector: 'app-referring-physician-view-component',
  templateUrl: './referring-physician-view-control.component.html',
  styleUrls: ['./referring-physician-view-control.component.css']
})

export class ReferringPhysicianViewComponent implements OnInit {

  @Input() referringPhysicianView: ReferringPhysicianView;
  @Input() referringPhysicianId: number;
  public form: FormGroup;
  loading = false;

  constructor(private notificationToastService: NotificationToastService
    , private formBuilder: FormBuilder
    , private physicianService: PhysicianService) {

    this.form = this.formBuilder.group({
      LastName: new FormControl({ value: '', disabled: true }),
      FirstName: new FormControl({ value: '', disabled: true }),
      Sex: new FormControl({ value: '', disabled: true }),
      Relevance: new FormControl({ value: '', disabled: true }),
      Country: new FormControl({ value: '', disabled: true }),
      Province: new FormControl({ value: '', disabled: true }),
      Locality: new FormControl({ value: '', disabled: true }),
      AddressStreet: new FormControl({ value: '', disabled: true }),
      AddressNumber: new FormControl({ value: '', disabled: true }),
      Floor: new FormControl({ value: '', disabled: true }),
      AddressDpto: new FormControl({ value: '', disabled: true }),
      PersonalPhone: new FormControl({ value: '', disabled: true }),
      LaborPhone: new FormControl({ value: '', disabled: true }),
      CellPhone: new FormControl({ value: '', disabled: true }),
      Email: new FormControl({ value: '', disabled: true }),
      NationalRegistration : new FormControl({ value: '', disabled: true }),
      ProvincialRegistration : new FormControl({ value: '', disabled: true }),
      SpecialityRegistration : new FormControl({ value: '', disabled: true }),
    });
  }

  get f() { return this.form.controls; }

  public async loadReferringPhysician() {
    if (this.form) {
      try {
        this.loading = true;
        if (!this.referringPhysicianView || (this.referringPhysicianId
            && (!this.referringPhysicianView  || this.referringPhysicianView.Id !== this.referringPhysicianId))) {
          this.referringPhysicianView = await this.physicianService.getReferringPhysicianView( this.referringPhysicianId);
        }
        if (this.referringPhysicianView) {
          this.form.patchValue({
            LastName: this.referringPhysicianView.LastName,
            FirstName: this.referringPhysicianView.FirstName,
            Sex: this.referringPhysicianView.Sex,
            Relevance: this.referringPhysicianView.Relevance,
            Country: this.referringPhysicianView.Country,
            Province: this.referringPhysicianView.Province,
            Locality: this.referringPhysicianView.Locality,
            AddressStreet: this.referringPhysicianView.AddressStreet,
            AddressNumber: this.referringPhysicianView.AddressNumber,
            Floor: this.referringPhysicianView.Floor,
            AddressDpto: this.referringPhysicianView.AddressDpto,
            PersonalPhone: this.referringPhysicianView.PersonalPhone,
            LaborPhone: this.referringPhysicianView.LaborPhone,
            CellPhone: this.referringPhysicianView.CellPhone,
            Email: this.referringPhysicianView.Email,
            NationalRegistration : this.referringPhysicianView.NationalRegistration,
            ProvincialRegistration : this.referringPhysicianView.ProvincialRegistration,
            SpecialityRegistration : this.referringPhysicianView.SpecialityRegistration,
          });
        }
      } catch (err) {
        this.notificationToastService.error(JSON.stringify(err.error), 'Médico derivante');
      } finally {
        this.loading = false;
      }
    }
  }



  async ngOnInit() {
    await this.loadReferringPhysician();
  }
}
